const URLS = {
  production: 'https://api.kotobekia.com',
  development: 'https://api-dev.kotobekia.com',
} as const;

export type Environment = keyof typeof URLS;

const STORAGE_KEY = 'kotobekia_active_env';

/**
 * Get the currently active environment from localStorage.
 * Defaults to 'production' if nothing is stored.
 */
export function getActiveEnv(): Environment {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'development' || stored === 'production') return stored;
  return 'production';
}

/**
 * Get the base URL for the currently active environment.
 */
export function getBaseUrl(): string {
  return URLS[getActiveEnv()];
}

/**
 * Toggle between production and development environments.
 * Persists the choice in localStorage and reloads the page so all
 * axios instances and sockets pick up the new URL cleanly.
 */
export function toggleEnvironment(): void {
  const current = getActiveEnv();
  const next: Environment = current === 'production' ? 'development' : 'production';
  localStorage.setItem(STORAGE_KEY, next);
  window.location.reload();
}

export { URLS };
